import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../components/Card';
import Button from '../components/Button';

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const [projectId, setProjectId] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!projectId.trim()) {
      setError('Veuillez entrer un ID de projet');
      return;
    }

    // Rediriger vers la page du projet
    navigate(`/projects/${projectId.trim()}`);
  };

  const goToAdmin = () => {
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="max-w-md w-full space-y-8">
        {/* Header */}
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-2">Espace Client</h1>
        </div>

        {/* Formulaire d'accès projet */}
        <Card>
          <h2 className="text-2xl font-bold text-center mb-6">Accéder à un projet</h2>

          {error && <p className="text-red-500 text-sm mb-4">{error}</p>}

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">
                ID du projet
              </label>
              <input
                type="text"
                value={projectId}
                onChange={(e) => setProjectId(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Entrez l'ID du projet"
                required
              />
            </div>

            <Button type="submit" className="w-full mb-4">
              Accéder au projet
            </Button>
          </form>

          <div className="text-center">
            <button
              onClick={goToAdmin}
              className="text-blue-600 hover:text-blue-800 text-sm font-medium"
            >
              Administration →
            </button>
          </div>
        </Card>

      </div>
    </div>
  );
};

export default HomePage;
